export const THEME = {
  palette: {
    common: {
      white: '#FFFFFF',
      black: '#000000DE',
    },
    primary: {
      light: '#ADDBFF',
      main: '#2196F3',
      dark: '#096BDE',
    },
    secondary: {
      main: '#F4EAFF',
      dark: '#5F35AE',
    },
    text: {
      primary: '#272930',
      secondary: '#054DA7',
      disabled: '#000000de',
    },
    blue: {
      100: '#DDF1FF',
    },
    grey: {
      A100: '#81848F',
      A200: '#646872',
      A300: '#EEEFF0',
      A400: '#0000008f',
      A700: '#000000cc',
      100: '#DDDEE0',
      400: '#484848',
    },
    black: {
      A100: 'rgba(0, 0, 0, 0.87)',
    },
    purple: {
      100: '#F4EAFF',
      600: '#5F35AE',
    },
    green: {
      500: '#5FD85F',
    },
    error: {
      main: '#D32F2F',
      light: '#FDEDED',
    },
  },
}

export const fontSize = {
  9: '0.56rem',
  12: '0.75rem',
  14: '0.875rem',
  16: '1rem',
  18: '1.15rem',
  20: '1.20rem',
}

export const lineHeight = {
  21: '21px',
  28: '28px',
  56: '56.02px',
}

export const borderRadius = {
  8: '8px',
  24: '24px',
  50: '50%',
}
